module.exports = __webpack_public_path__ + "img/premium-img-5.e4fe8a2e.png";